module.exports = __webpack_public_path__ + "static/media/event11.221b65c9.jpg";